export default __webpack_public_path__ + "static/media/curseofset.04740ceb.png";